/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowFamilySportsDayTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowFamilySportsDay,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Get Active Together!",
    "Family Sports Day Awaits!",
    "Fun and Games for Everyone!",
  ],
  title: "Family Sports Day",
  description: "Organize a fun family sports day.",
  longDescription:
    "Gather your family for an exciting sports day! Choose a date, decide on activities, and plan refreshments!",
  emoji: "⚽",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Family Sports Day",
          emoji: "⚽",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we hold the family sports day?",
          emoji: "📅",
          completeAction: {
            question: "Decide on sports activities?",
            description: "What activities should we focus on during the day?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What sports should we consider?",
                emoji: "🏀",
                completeAction: {
                  question: "Decide on refreshments?",
                  description: "What refreshments should we plan for the day?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What refreshments should we bring?",
                      emoji: "🍉",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Get Moving!",
    outroDescription: "Your family sports day plans are set! Enjoy the fun!",
  },
};
